import { useSessionSync } from '@/auth/sessionSync';
import { LoadingScreen } from '@/components';
import { useAuth } from '@/hooks';
import { MainLayout } from '@/layouts';
import { Router } from '@/routes';

import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@/styles/global.scss';

function App() {
  const auth = useAuth();
  useSessionSync();

  if (auth.isLoading) {
    return <LoadingScreen />;
  }

  if (!auth.isAuthenticated) {
    return (
      <button type="button" onClick={() => void auth.signinRedirect()}>
        Log in
      </button>
    );
  }

  return (
    <MainLayout>
      <Router />
    </MainLayout>
  );
}

export default App;
